module.exports = __webpack_public_path__ + "img/gift_jbl_tt_fr.262eb05b.jpg";